module.exports = __webpack_public_path__ + "img/BatAgriToitO.dd5177f9.png";